
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/forgot-password",
      function () {
        return require("private-next-pages/[locale]/forgot-password.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/forgot-password"])
      });
    }
  